import React from "react";
import { notification, Empty, Button, Col, Row } from "antd";
import { compose } from "recompose";
import { graphql, withApollo } from "react-apollo";
import { withGlobal } from "../../../component-global";
import Container, { TitleGoBack } from "../../../components/Container";
import { CustomFilterContainer } from "../../../components/Form/SearchContainer";
import { TableList } from "../../GlobalComponent";
import { captureException } from "../../../utils/sentry";
import { AFFILIATES_AGENCY_VIEW } from "../../../utils/permissions";
import {
  getAffiliatesByAgencyID,
  getInfoAgencyByID,
  statusAffiliates,
  getAllCountries,
} from "../../../graphQl/queries/affiliate";
import ModalAffiliate from "../Affiliates/components/Modal";
import AgencyDashboardHeader from "./components/AgencyDashboardHeader";
import AffiliatesAgencySearchBar from "./components/AffiliatesAgencySearchBar";
import ModalDeleteAffiliate from "./components/ModalDeleteAffiliate";
import DrawerComponent from "./components/Drawer";
import ModalSendAccount from "./components/ModalSendAccount";
import ModalUploadAffiliatesCsv from "./components/ModalUploadAffiliatesCsv";
import ModalCreateAffiliate from "./components/ModalCreateAffiliate";
import {
  AgencyModuleGlobalStyles,
  AGENCY_MODULE_CLASS,
  AGENCY_PORTAL_CLASS,
} from "./components/style";

const EMPTY_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/chazki-link.appspot.com/o/ZeldaB2B%2Fempty.png?alt=media&token=f75af418-98b3-4bf7-b173-24927b73d29e";

class AffiliatesByAgency extends React.Component {
  constructor(props) {
    super(props);

    const getPermissionsView =
      typeof props.getPermissionsView === "function"
        ? props.getPermissionsView
        : () => ({ view: false, edit: false, create: false, admin: false });

    if (typeof props.isAllowedView === "function") {
      props.isAllowedView(AFFILIATES_AGENCY_VIEW);
    }

    this.state = {
      pagination: { limit: 15, page: 0 },
      currentFilter: null,
      itemsSelected: [],
      detailItemsSelected: [],
      loadingBtnSearch: false,
      loadingActions: false,
      loadingButonChangeState: false,
      visibleModal: false,
      visibleModalDeleteAffiliate: false,
      visibleDrawer: false,
      visibleModalSendEmailAccount: false,
      visibleModalCsv: false,
      visibleModalCreateAffiliate: false,
      idAgency: -1,
      affiliateSelected: null,
      affiliateUserIDSelected: null,
      affiliateNamesSelected: null,
      affiliateEmailSelected: null,
      affiliatePasswordSelected: null,
      dataAgency: null,
      totalAffiliates: null,
      nameAgency: "Afiliados por agencia",
      showDaliAffiliateColumn: false,
      permissionsView: getPermissionsView(AFFILIATES_AGENCY_VIEW),
    };
  }

  componentDidMount = async () => {
    try {
      this.setState({ loadingActions: true });
      const {
        data: { getInfoAgencyByID: dataAgency },
      } = await this.props.client.query({
        fetchPolicy: "network-only",
        query: getInfoAgencyByID,
        variables: {
          agencyID: parseInt(this.props.agencyID, 10),
        },
      });
      this.setState({
        loadingActions: false,
        idAgency: dataAgency.id,
        nameAgency: dataAgency.name,
      });
    } catch (err) {
      captureException(err);
      this.setState({ loadingActions: false });
      notification.error({
        message: "Hubo un error al cargar la información de la agencia.",
      });
    }
  };

  searchAgency = async filter => {
    try {
      this.setState({ loadingBtnSearch: true, currentFilter: filter });
      const { pagination } = this.state;
      const {
        data: { getAffiliatesByAgencyID: dataInitialAffiliates },
      } = await this.props.client.query({
        fetchPolicy: "network-only",
        query: getAffiliatesByAgencyID,
        variables: {
          agencyID: parseInt(this.props.agencyID, 10),
          ...filter,
          limit: pagination.limit,
          offset: 0,
        },
      });

      this.setState({
        pagination: { limit: pagination.limit, page: 0 },
        dataAgency: dataInitialAffiliates.rows,
        totalAffiliates: dataInitialAffiliates.count,
        loadingBtnSearch: false,
      });
    } catch (err) {
      captureException(err);
      this.setState({ loadingBtnSearch: false });
      notification.error({
        message: "Hubo un error al actualizar los datos.",
      });
    }
  };

  onChangePagination = async (page, pageSize) => {
    try {
      this.setState({ loadingActions: true });
      const { pagination, currentFilter } = this.state;
      const limit = pageSize || pagination.limit;
      const {
        data: { getAffiliatesByAgencyID: dataAffiliates },
      } = await this.props.client.query({
        fetchPolicy: "network-only",
        query: getAffiliatesByAgencyID,
        variables: {
          agencyID: parseInt(this.props.agencyID, 10),
          ...currentFilter,
          limit,
          offset: (page - 1) * limit,
        },
      });

      this.setState({
        pagination: { limit, page: page - 1 },
        dataAgency: dataAffiliates.rows,
        totalAffiliates: dataAffiliates.count,
        loadingActions: false,
      });
    } catch (err) {
      captureException(err);
      this.setState({ loadingActions: false });
      notification.error({
        message: "Hubo un error al actualizar los datos.",
      });
    }
  };

  onSelectChange = (selectedRowKeys, selectData) => {
    this.setState({
      itemsSelected: selectedRowKeys,
      detailItemsSelected: selectData,
    });
  };

  reloadTable = async () => {
    try {
      this.setState({ loadingBtnSearch: true });
      const { pagination, currentFilter, itemsSelected } = this.state;
      const {
        data: { getAffiliatesByAgencyID: dataInitialAffiliates },
      } = await this.props.client.query({
        fetchPolicy: "network-only",
        query: getAffiliatesByAgencyID,
        variables: {
          agencyID: parseInt(this.props.agencyID, 10),
          ...currentFilter,
          limit: pagination.limit,
          offset: 0,
        },
      });

      const newRows = dataInitialAffiliates.rows;
      const keptKeys = itemsSelected.filter(id =>
        newRows.some(row => row.userID === id)
      );
      const detailItemsSelected = newRows.filter(row =>
        keptKeys.includes(row.userID)
      );

      this.setState({
        pagination: { limit: pagination.limit, page: 0 },
        dataAgency: newRows,
        totalAffiliates: dataInitialAffiliates.count,
        loadingBtnSearch: false,
        itemsSelected: keptKeys,
        detailItemsSelected,
      });
    } catch (err) {
      captureException(err);
      this.setState({ loadingBtnSearch: false });
      notification.error({
        message: "Hubo un error al actualizar los datos.",
      });
    }
  };

  changeVisibleModal = () => {
    if (!this.state.permissionsView?.edit) {
      notification.warning({
        message: "No tiene permisos para cambiar el estado de afiliados.",
      });
      return;
    }

    this.setState({ visibleModal: true });
  };

  handleCancelModal = () => {
    this.setState({ visibleModal: false });
  };

  handleShowModalDeleteAffiliate = () => {
    if (!this.state.permissionsView?.edit) {
      notification.warning({
        message: "No tiene permisos para eliminar afiliados.",
      });
      return;
    }

    this.setState({ visibleModalDeleteAffiliate: true });
  };

  handleCancelModalDeleteAffiliate = () => {
    this.setState({ visibleModalDeleteAffiliate: false });
  };

  openCreateAffiliateModal = () => {
    const { permissionsView } = this.state;

    if (!permissionsView?.create) {
      notification.warning({
        message: "No tiene permisos para crear afiliados.",
      });
      return;
    }

    this.setState({ visibleModalCreateAffiliate: true });
  };

  closeCreateAffiliateModal = () => {
    this.setState({ visibleModalCreateAffiliate: false });
  };

  handleCreateAffiliateSuccess = extra => {
    this.setState({
      visibleModalCreateAffiliate: false,
      affiliateUserIDSelected: extra.userID,
      affiliateNamesSelected: extra.namesUser,
      affiliateEmailSelected: extra.emailUser,
      affiliatePasswordSelected: extra.password,
      visibleModalSendEmailAccount: true,
    });
    this.reloadTable();
  };

  openCsvModal = () => {
    const { permissionsView } = this.state;

    if (!permissionsView?.create) {
      notification.warning({
        message: "No tiene permisos para crear afiliados.",
      });
      return;
    }

    this.setState({ visibleModalCsv: true });
  };

  closeCsvModal = () => {
    this.setState({ visibleModalCsv: false });
  };

  openDrawerAffiliate = (userID, namesUser, emailUser) => {
    if (!this.state.permissionsView?.edit) {
      notification.warning({
        message: "No tiene permisos para editar afiliados.",
      });
      return;
    }

    this.setState({
      visibleDrawer: true,
      affiliateSelected: userID,
      affiliateUserIDSelected: userID,
      affiliateNamesSelected: namesUser,
      affiliateEmailSelected: emailUser,
    });
  };

  updateAffiliateSelected = ({ userID, namesUser, emailUser, password }) => {
    this.setState({
      affiliateUserIDSelected: userID,
      affiliateNamesSelected: namesUser,
      affiliateEmailSelected: emailUser,
      affiliatePasswordSelected: password,
    });
  };

  handleCancelDrawer = () => {
    this.setState({
      visibleDrawer: false,
      affiliateSelected: null,
    });
  };

  showModalSendEmailAccount = () => {
    this.setState({ visibleModalSendEmailAccount: true });
  };

  // se limpia la contraseña para que el siguiente "Generar contraseña" no
  // muestre la de un afiliado creado anteriormente
  hideModalSendEmailAccount = () => {
    this.setState({
      visibleModalSendEmailAccount: false,
      affiliatePasswordSelected: null,
    });
  };

  getColumns = canEdit => {
    const { showDaliAffiliateColumn } = this.state;
    const columns = [
    {
      title: "Nombres",
      dataIndex: "names",
      key: "names",
      width: 100,
      render: (text, record) => (
        <span style={{ fontSize: "14px" }}>{record.User.names}</span>
      ),
    },
    {
      title: "Apellidos",
      dataIndex: "lastname",
      key: "lastname",
      width: 100,
      render: (text, record) => (
        <span style={{ fontSize: "14px" }}>{record.User.lastname}</span>
      ),
    },
    {
      title: "Numero de documento",
      dataIndex: "documentoNumber",
      key: "documentNumber",
      width: 80,
      render: (text, record) => (
        <span style={{ fontSize: "14px" }}>{record.User.documentNumber}</span>
      ),
    },
    {
      title: "Telefono",
      dataIndex: "phone",
      key: "phone",
      width: 80,
      render: (text, record) => (
        <span style={{ fontSize: "14px" }}>{record.User.phone}</span>
      ),
    },
    {
      title: "Correo",
      dataIndex: "email",
      key: "email",
      width: 80,
      render: (text, record) => (
        <span style={{ fontSize: "14px" }}>{record.User.email}</span>
      ),
    },
    {
      title: "Etapa",
      dataIndex: "step",
      key: "step",
      width: 100,
      render: (text, record) => (
        <span style={{ fontSize: "14px" }}>{record.Step.name}</span>
      ),
    },
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      width: 80,
      render: (text, record) => (
        <span style={{ fontSize: "14px" }}>{record.Status.subclass}</span>
      ),
    },
    ];

    if (showDaliAffiliateColumn) {
      columns.push({
        title: "Afiliado a Dali",
        dataIndex: "daliAffiliate",
        key: "daliAffiliate",
        width: 90,
        render: (text, record) =>
          record.isAffiliateDali ? (
            <span
              style={{
                textTransform: "capitalize",
                fontSize: "14px",
              }}
            >
              Si
            </span>
          ) : (
            <Button
              type="link"
              disabled
              key={record.userID}
              style={{ padding: "0px" }}
            >
              <span style={{ textDecoration: "underline", color: "#307FE2" }}>
                No, afiliar
              </span>
            </Button>
          ),
      });
    }

    if (canEdit) {
      columns.push({
        title: "Editar",
        dataIndex: "moreinfo",
        key: "moreinfo",
        width: 90,
        render: (text, record) => (
          <Button
            type="link"
            onClick={() =>
              this.openDrawerAffiliate(
                record.userID,
                `${record.User.names} ${record.User.lastname}`,
                record.User.email
              )
            }
            key={record.userID}
          >
            <span style={{ textDecoration: "underline", color: "#307FE2" }}>
              Editar datos
            </span>
          </Button>
        ),
      });
    }

    return columns;
  };

  render() {
    const {
      pagination,
      dataAgency,
      totalAffiliates,
      itemsSelected,
      detailItemsSelected,
      loadingActions,
      loadingBtnSearch,
      loadingButonChangeState,
      visibleModal,
      visibleModalDeleteAffiliate,
      visibleDrawer,
      visibleModalSendEmailAccount,
      visibleModalCsv,
      visibleModalCreateAffiliate,
      idAgency,
      affiliateSelected,
      affiliateUserIDSelected,
      affiliateNamesSelected,
      affiliateEmailSelected,
      affiliatePasswordSelected,
      nameAgency,
      permissionsView,
    } = this.state;

    const {
      getAffiliatesByAgencyID: {
        getAffiliatesByAgencyID: dataInitialAffiliates,
        loading: loadingDataAffiliates,
      },
      statusAffiliates: { searchGeneralTypesBy: StatusAffiliates },
      getAllCountries: { getAllCountries: dataCountries },
    } = this.props;

    const dataResult = permissionsView.view
      ? dataAgency || (dataInitialAffiliates && dataInitialAffiliates.rows)
      : [];
    const totalResult = permissionsView.view
      ? totalAffiliates ||
        (dataInitialAffiliates && dataInitialAffiliates.count)
      : 0;
    const stateLoadingAllState =
      loadingActions || loadingDataAffiliates || loadingBtnSearch;

    const rowSelection = {
      selectedRowKeys: itemsSelected,
      onChange: this.onSelectChange,
    };

    const authEditDrawer = permissionsView ? permissionsView.edit : false;
    const bulkActionsDisabled = itemsSelected.length === 0 || !authEditDrawer;

    const columns = this.getColumns(authEditDrawer);

    return (
      <div
        className={AGENCY_MODULE_CLASS}
        style={{
          minHeight: "100vh",
          background: "#e5e5e5",
        }}
      >
        <AgencyModuleGlobalStyles />
        <AgencyDashboardHeader />
        <Container>
          <TitleGoBack title={nameAgency} />
          <CustomFilterContainer
            style={{ padding: "24px ", marginBottom: "0px" }}
          >
            <AffiliatesAgencySearchBar
              loadingBtnSearch={stateLoadingAllState}
              searchAgency={this.searchAgency}
              openDrawer={this.openCreateAffiliateModal}
              openCsvModal={this.openCsvModal}
              permissionsView={permissionsView}
            />
            {dataResult && dataResult.length > 0 ? (
              <div>
                <TableList
                  rowSelection={authEditDrawer ? rowSelection : undefined}
                  data={dataResult}
                  columns={columns}
                  loading={stateLoadingAllState}
                  pageSize={pagination.limit}
                  totalData={totalResult}
                  currentPage={pagination.page + 1}
                  onChange={this.onChangePagination}
                  heightcustom="calc(100vh - 510px)"
                  scroll={{ y: "calc(100vh - 510px)" }}
                  size="middle"
                  rowKey="userID"
                />
                {authEditDrawer && (
                <Row gutter={24} type="flex" justify="end">
                  <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                    <Button
                      htmlType="button"
                      type="primary"
                      onClick={this.changeVisibleModal}
                      loading={loadingButonChangeState}
                      disabled={bulkActionsDisabled}
                      style={{
                        margin: "16px 0 0",
                        height: 40,
                        width: "100%",
                        fontFamily: "Gilroy, sans-serif",
                        fontWeight: 600,
                      }}
                    >
                      Cambiar estado
                    </Button>
                  </Col>
                  <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                    <Button
                      htmlType="button"
                      type="danger"
                      onClick={this.handleShowModalDeleteAffiliate}
                      loading={stateLoadingAllState}
                      disabled={bulkActionsDisabled}
                      style={{
                        margin: "16px 0 0",
                        height: 40,
                        width: "100%",
                        fontFamily: "Gilroy, sans-serif",
                        fontWeight: 600,
                      }}
                    >
                      Eliminar
                    </Button>
                  </Col>
                </Row>
                )}
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "calc(100vh - 350px)",
                  padding: "0 8px 0 0",
                }}
              >
                <Empty
                  image={EMPTY_IMAGE}
                  imageStyle={{ height: 136 }}
                  description={null}
                >
                  <span
                    style={{
                      color: "#8C8C8C",
                      fontStyle: "normal",
                      fontWeight: "500",
                      fontSize: "16px",
                      lineHeight: "20px",
                    }}
                  >
                    {loadingDataAffiliates
                      ? "Cargando ..."
                      : "No hemos encontrado información disponible"}
                  </span>
                </Empty>
              </div>
            )}
          </CustomFilterContainer>
        </Container>
        {visibleModalDeleteAffiliate && (
          <ModalDeleteAffiliate
            onHandleCancelModal={this.handleCancelModalDeleteAffiliate}
            loadTable={this.reloadTable}
            visible={visibleModalDeleteAffiliate}
            dataSelected={detailItemsSelected}
            permissionsView={permissionsView}
          />
        )}
        {visibleModal && (
          <ModalAffiliate
            onHandleCancelModal={this.handleCancelModal}
            visible={visibleModal}
            wrapClassName={AGENCY_PORTAL_CLASS}
            affiliatesIDsSelected={detailItemsSelected.map(item => item.userID)}
            statusAffiliates={StatusAffiliates}
            loadTable={this.reloadTable}
            permissionsView={permissionsView}
          />
        )}
        {visibleDrawer && affiliateSelected != null && permissionsView.edit && (
          <DrawerComponent
            key={affiliateSelected}
            onClose={this.handleCancelDrawer}
            visible={visibleDrawer}
            agencyID={
              idAgency > 0 ? idAgency : parseInt(this.props.agencyID, 10)
            }
            userID={affiliateSelected}
            dataCountries={dataCountries}
            loadTable={this.reloadTable}
            onHandleCancelModal={this.hideModalSendEmailAccount}
            showModalSendEmailAccount={this.showModalSendEmailAccount}
            permissionsView={permissionsView}
          />
        )}
        {visibleModalSendEmailAccount && (
          <ModalSendAccount
            onHandleCancelModal={this.hideModalSendEmailAccount}
            visible={visibleModalSendEmailAccount}
            userID={affiliateUserIDSelected}
            names={affiliateNamesSelected}
            email={affiliateEmailSelected}
            password={affiliatePasswordSelected}
          />
        )}
        {visibleModalCreateAffiliate && (
          <ModalCreateAffiliate
            visible={visibleModalCreateAffiliate}
            agencyID={
              idAgency > 0 ? idAgency : parseInt(this.props.agencyID, 10)
            }
            onClose={this.closeCreateAffiliateModal}
            onSuccess={this.handleCreateAffiliateSuccess}
          />
        )}
        {visibleModalCsv && (
          <ModalUploadAffiliatesCsv
            visible={visibleModalCsv}
            agencyID={
              idAgency > 0 ? idAgency : parseInt(this.props.agencyID, 10)
            }
            onClose={this.closeCsvModal}
            onSuccess={this.reloadTable}
          />
        )}
      </div>
    );
  }
}

export default compose(
  graphql(getAffiliatesByAgencyID, {
    name: "getAffiliatesByAgencyID",
    options: props => ({
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      variables: {
        agencyID: parseInt(props.agencyID, 10),
        offset: 0,
        limit: 15,
      },
    }),
  }),
  graphql(statusAffiliates, {
    name: "statusAffiliates",
    options: () => ({
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      variables: {},
    }),
  }),
  graphql(getAllCountries, {
    name: "getAllCountries",
    options: () => ({
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      variables: {},
    }),
  }),
  withApollo
)(withGlobal(AffiliatesByAgency));
